import {
  laravelGet,
  laravelPost,
} from '../utils/laravelClient';

const LOYALTY = { auth: 'loyalty', context: { redirectOnFailure: false } };
const AUTH = { auth: 'admin' };

export const fetchReservationOptions = () =>
  laravelGet('/loyalty/reservations/options', LOYALTY);

export const fetchReservationAvailability = (params) =>
  laravelGet('/loyalty/reservations/availability', { ...LOYALTY, params });

export const fetchMyReservations = () =>
  laravelGet('/loyalty/reservations', LOYALTY);

export const createLoyaltyReservation = (data) =>
  laravelPost('/loyalty/reservations', data, LOYALTY);

export const cancelLoyaltyReservation = (id) =>
  laravelPost(`/loyalty/reservations/${id}/cancel`, null, LOYALTY);

export const fetchLoyaltyReservationsForDay = (date) =>
  laravelGet('/loyalty-reservations', { ...AUTH, params: { date } });

export const previewLoyaltyReservation = (id) =>
  laravelPost(`/loyalty-reservations/${id}/preview`, null, AUTH);

export const approveLoyaltyReservation = (id, payload) =>
  laravelPost(`/loyalty-reservations/${id}/approve`, payload, AUTH);

export const denyLoyaltyReservation = (id, payload) =>
  laravelPost(`/loyalty-reservations/${id}/deny`, payload, AUTH);

export const markLoyaltyReservationNoShow = (id, payload = {}) =>
  laravelPost(`/loyalty-reservations/${id}/no-show`, payload, AUTH);

export const unblockLoyaltyUserReservations = (loyaltyUserId) =>
  laravelPost(`/loyalty-users/${loyaltyUserId}/reservations-unblock`, null, AUTH);
